module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "masthead container"
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": "/"
    }
  }, [_c('Logo', {
    attrs: {
      "width": 160,
      "height": 155
    }
  })], 1), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "nav-item noMob"
  }, [_c('span', [_vm._v("Connect with Us!")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "target": "_blank",
      "href": "https://www.facebook.com/pencilsforkidsincUSA/"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "target": "_blank",
      "href": "https://www.instagram.com/pencilsforkidsinc/"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "target": "_blank",
      "href": "https://www.pinterest.com/PFKInc/"
    }
  }, [_c('i', {
    staticClass: "fa fa-pinterest-p"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "target": "_blank",
      "href": "https://www.youtube.com/@pencilsforkidsinc"
    }
  }, [_c('i', {
    staticClass: "fa fa-youtube"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7b159c9a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/Masthead.vue
// module id = 404
// module chunks = 2